import React, { ReactElement } from "react";
import { Stack, Icon, Text } from "sprint-common-web";

import { BuzzContentReferenceResponse } from "../../../common/api/catalogue-api/buzz/BuzzContentReferenceResponse";

const getIconByMode = (mode: boolean): JSX.Element => {
    const iconName = mode ? "Accept" : "Cancel";
    return <Icon iconName={iconName} display="some" alignItems="center" />;
};
export const renderBuzzItem = (props: BuzzContentReferenceResponse | undefined): ReactElement | null => {
    if (!props) {
        return null;
    }
    const { id, isArchived, isDeleted } = props;

    return (
        <Stack>
            <Stack verticalAlign="center">
                <Text value={`Id: ${id}`} styles={{ root: { fontSize: 12 } }}></Text>
            </Stack>
            <Stack horizontal={true} verticalAlign="center">
                <Text value="Archived:" styles={{ root: { paddingRight: 10, fontSize: 12 } }}></Text>
                {getIconByMode(isArchived)}
            </Stack>
            <Stack verticalAlign="center" horizontal={true}>
                <Text value="Deleted:" styles={{ root: { paddingRight: 10, fontSize: 12 } }}></Text>
                {getIconByMode(isDeleted)}
            </Stack>
        </Stack>
    );
};
